export const SET = {
  navSettings: "nav-settings",
  page: "settings-page",
  title: "settings-title",
  appearanceSection: "settings-appearance",
  pxMasterSection: "settings-px-master",
  pxMasterLink: "settings-px-master-link",
  masterDataSection: "settings-master-data",
  allergenMasterSection: "settings-allergen-master",
  allergenMasterLink: "settings-allergen-master-link",
  systemChangeHistorySection: "settings-system-change-history",
  systemChangeHistoryLink: "settings-system-change-history-link",
  smsSandboxSection: "settings-sms-sandbox-test",
  smsSandboxLink: "settings-sms-sandbox-test-link",
  accessControlSection: "settings-access-control",
  accessControlLink: "settings-access-control-link",
  genericReportDesignerSection: "settings-generic-report-designer",
  genericReportDesignerLink: "settings-generic-report-designer-link",
  databaseDesignerSection: "settings-database-designer",
  databaseDesignerLink: "settings-database-designer-link",
  pageBackgroundSwitch: "settings-page-background-switch",
  pageBackgroundSwatches: "settings-page-background-swatches",
  pageBackgroundSwatch: "settings-page-background-swatch",
};
